module.exports = __webpack_public_path__ + "img/title_back_mid.10ba90f1.png";